import {
  OFFER_SIM_PURCHASE,
  OFFER_SIM_PURCHASE_ERROR,
  CLEAN_OFFER_SIM_PURCHASE,
  CLEAN_OFFER_SIM_PURCHASE_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function offerSimPurchaseReducer(state = initialState, action) {
  switch (action.type) {
    case OFFER_SIM_PURCHASE:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case OFFER_SIM_PURCHASE_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_OFFER_SIM_PURCHASE:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_OFFER_SIM_PURCHASE_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
